import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  TextField,
  Typography,
  Box,
  useTheme,
} from "@mui/material";
import { useLogger } from "../../../../contexts/LoggerContext";
import { RosterPlayer } from "../../../../types/LogTypes";
import { PlayerSelection } from "../Components/PlayerSelection";
import { YardlineInput } from "../Components/YardlineInput";

export const FieldGoalBlockKickLog = ({
  kickType,
  setKickType,
}: {
  kickType: "PAT" | "FG";
  setKickType: (kickType: "PAT" | "FG") => void;
}) => {
  const {
    setCurrentPlayLog,
    gameSituation,
    setGameSituation,
    clearSelections,
  } = useLogger();

  const [fieldGoalDistance, setFieldGoalDistance] = useState<number>(
    gameSituation.yardline + 17
  );
  const [fieldGoalResult, setFieldGoalResult] = useState<
    "GOOD" | "MISSED" | "BLOCKED" | null
  >(null);

  useEffect(() => {
    if (clearSelections) {
      setFieldGoalDistance(gameSituation.yardline + 7);
      setFieldGoalResult(null);
    }
  }, [clearSelections]);

  useEffect(() => {
    if (fieldGoalResult) {
      setCurrentPlayLog({
        field_goal_distance: fieldGoalDistance,
        field_goal_result: fieldGoalResult,
        pat: kickType === "PAT",
      });
    }
  }, [fieldGoalDistance, fieldGoalResult]);
  return (
    <Box>
      <Grid container>
        {/* Field Goal Distance */}
        <Grid item xs={8}>
          <YardlineInput
            value={fieldGoalDistance}
            onChange={setFieldGoalDistance}
            label="Field Goal Distance"
          />
        </Grid>

        {/* Field Goal Result */}
        <Grid item xs={8}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              maxWidth: 600,
              mt: 2,
            }}
          >
            <Button
              variant={fieldGoalResult === "GOOD" ? "contained" : "outlined"}
              color={fieldGoalResult === "GOOD" ? "success" : "primary"}
              sx={{
                minWidth: 150,
                fontWeight: fieldGoalResult === "GOOD" ? "bold" : "normal",
              }}
              onClick={() => {
                setFieldGoalResult("GOOD");
                setGameSituation({
                  ...gameSituation,
                  opp_score:
                    gameSituation.opp_score + (kickType === "PAT" ? 1 : 3),
                });
              }}
            >
              Good
            </Button>
            <Button
              variant={fieldGoalResult === "MISSED" ? "contained" : "outlined"}
              color={fieldGoalResult === "MISSED" ? "error" : "primary"}
              sx={{
                minWidth: 150,
                fontWeight: fieldGoalResult === "MISSED" ? "bold" : "normal",
              }}
              onClick={() => setFieldGoalResult("MISSED")}
            >
              Missed
            </Button>
            <Button
              variant={fieldGoalResult === "BLOCKED" ? "contained" : "outlined"}
              color={fieldGoalResult === "BLOCKED" ? "error" : "primary"}
              sx={{
                minWidth: 150,
                fontWeight: fieldGoalResult === "BLOCKED" ? "bold" : "normal",
              }}
              onClick={() => setFieldGoalResult("BLOCKED")}
            >
              Blocked
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
